import { addDays, format, formatISO, formatRFC3339, parseISO } from "date-fns";
import { useState } from "react";
import { useAuth } from "./authStore";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
const queryString = require("query-string");

export type CalendarEvent = {
  summary: string;
  schedule: {
    start: Date;
    end: Date;
  };
};

const fetchFromGoogle = (
  url: string,
  token: string,
  qs: { [x: string]: string }
) => {
  const builtUrl =
    Object.keys(qs).length > 0 ? url + `?${queryString.stringify(qs)}` : url;
  return fetch(builtUrl, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((rsp) => rsp.json());
};

const print = (data) => {
  console.log("bingo bongo", data);
};

/*
    fetchFromGoogle(
      "https://www.googleapis.com/calendar/v3/users/me/calendarList",
      accessToken
    ).then(print);
*/

const googleEventAdapter = (event: gapi.client.calendar.Event) => {
  return {
    summary: event.summary!,
    schedule: {
      start: parseISO(event.start?.dateTime!),
      end: parseISO(event.end?.dateTime!),
    },
  } as CalendarEvent;
};

export const useCalendarEvents = (start: Date, end: Date) => {
  const auth = useAuth();
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [initialized, setInit] = useState(false);

  const handleEvents = (eventsRsp: gapi.client.calendar.Events) => {
    if (!eventsRsp.items) {
      return [];
    }
    setInit(true);
    setEvents(eventsRsp.items.map(googleEventAdapter));
  };

  console.log("creds =", auth?.creds);

  if (auth?.creds && !initialized) {
    //@ts-ignore
    const accessToken = auth?.creds.accessToken;
    const qs = {
      timeMin: formatRFC3339(start),
      timeMax: formatRFC3339(end),
    };

    fetchFromGoogle(
      //2021-06-13T15:07:46Z&timeMin=2021-06-11T15:07:46Z
      `https://www.googleapis.com/calendar/v3/calendars/team.interintellect@gmail.com/events`,
      accessToken,
      qs
    ).then(handleEvents);
  }

  return events;
};
